import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { MappingListModel } from '../../../models/mappinglist.model';
import { MappingEntityInterface } from '../mapping-entity.interface';


@Component({
  selector: 'hhsg-mapping-list',
  templateUrl: './mapping-list.component.html',
  styleUrls: ['./mapping-list.component.scss']
})
export class MappingListComponent {
  @Input() mappingDetailTemplate: TemplateRef<HTMLElement>;
  @Input() mappings: MappingEntityInterface[];
  @Input() hasLegends: boolean;
  @Input() selection: any;

  @Output() onSelectionEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  onSelection(mapping:any){
    this.onSelectionEvent.emit(mapping);
  }
  getIsActive(mapping: MappingEntityInterface): boolean {
    return mapping.id == this.selection.id;
  }

}
